const EMAIL_REGEX = /^([\w+-]\.?)+@[a-z\d-]+(\.[a-z0-9]+)*\.[a-z]+$/i

export const isEmailFormatValid = email => {
  return EMAIL_REGEX.test(email)
}

export const isEmail = (value = '') => {
  return value.includes('@')
}
